<template>
  <div class="flex flex-col items-center w-full">
    <div class="hex-wrapper relative w-14 md:w-32 aspect-[1/1.15]">
      <div class="hex-border" :class="{ 'hex-border-winning': isWinning }"></div>
      <div class="hex-inner">
        <img
            :src="gift?.url"
            alt="gift"
            class="w-full h-full object-cover"
        />
      </div>
    </div>
    <div class="mt-2 text-center">
      <el-tooltip class="item" effect="dark" :content="gift?.name" placement="top">
        <span class="text-[#FFD602] text-[13px] line-clamp-1 lg:text-[16px]">{{ gift?.name }}</span>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiftComponent',
  props: {
    gift: {
      type: Object,
      default:() => {},
    },
    isWinning: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>
.hex-wrapper {
  position: relative;
}

.hex-border {
  position: absolute;
  inset: 0;
  background: #ffd602;
  clip-path: polygon(
      50% 0%,
      100% 25%,
      100% 75%,
      50% 100%,
      0% 75%,
      0% 25%
  );
  z-index: 1;
}

.hex-border-winning {
  animation: hexPulse 1s ease-in-out infinite;
}

.hex-inner {
  position: absolute;
  inset: 3px;
  background: #000;
  clip-path: polygon(
      50% 0%,
      100% 25%,
      100% 75%,
      50% 100%,
      0% 75%,
      0% 25%
  );
  z-index: 2;
  overflow: hidden;
}

@keyframes hexPulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (min-width: 1024px) {
  .hex-inner {
    inset: 6px;
  }
}
</style>
